/* eslint-disable import/prefer-default-export */

/**
 * returns a partially-applied function with a signature for
 * customPropsMapper. we need to create a closure for postData since, by
 * default, customPropsMapper does not pass the bundle data.
 *
 * @export
 * @param {Object} [postData={}] post bundle data (title, publishedAt, etc.)
 * @returns {Function} partially-applied customPropsMapper function with postData available
 */
export function createAddPostDataToItem(post) {
  // eslint-disable-next-line no-unused-vars
  return function addPostDataToItem(itemProps, type, variant, idx, totalItems) {
    // CLEANUP: instead of merging post.data wholesale, we should consider only
    const props = {
      // merging the data we need
      ...itemProps,
      post: post.data
    };

    switch (type) {
      case 'ad':
        return {
          // CLEANUP: update <Ad> to use resourceId instead of getting it from
          // post then use ...item, resourceId
          ...props,
          resourceId: post.data.resourceId
        };
      case 'image':
        return {
          ...props,
          variant: idx === 0 ? 'mobile-full-bleed' : null,
          isAffiliate: post.isAffiliate
        };
      case 'html':
      case 'heading':
      case 'listicle':
      case 'product':
      case 'productTeaser':
      case 'productEmbed':
      case 'sideBySide':
      case 'faq':
        return {
          ...props,
          isAffiliate: post.isAffiliate,
          isSponsored: post.isSponsored,
          isAmp: post.isAmp
        };
      case 'gallery':
      case 'video':
      case 'inPostVideoAd':
        return {
          ...props,
          // CLEANUP: add post.data.ads.targeting as well and simplify components
          hideAds: post.hideAds,
          isAmp: post.isAmp
        };
      case 'recipe':
        return {
          ...props,
          // CLEANUP: add post.data.ads.targeting as well and simplify components
          hideAds: post.hideAds,
          hideComments: post.hideComments,
          hideAccountActions: post.hideAccountActions,
          isAmp: post.isAmp
        };
      default:
        return props;
    }
  };
}
